import { isNot } from 'typescript-styled-is'
import styled, { ITheme } from '../../theme'

const ColorsContainer = styled.div<IColorsContainerProps>`
  width: 100%;
  display: flex;
  position: relative;
  margin-top: ${({ size }) => (size ? 10 * size : 10)}px;
  flex-wrap: wrap;

  ${isNot('withCheckbox')`
    width: 200%;
    transform: translateX(-50%);
  `};

  @media (max-width: ${(props: ITheme) => props.theme.breakpoints.mobile}) {
    margin-top: ${({ size }) => (size ? 20 * size : 20)}px;
    display: grid;
    grid-template-columns: repeat(
      auto-fit,
      ${({ size }) => (size ? 60 * size : 60)}px
    );
    justify-content: space-between;
  }

  ${({ disabled,disabledIcon }) =>
    disabled &&
    `
    position: relative;

    &::after {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      z-index: 2;
      width: 100%;
      height: 100%;
      border-radius: 4px;
      border: 1px solid #D7D7D7;
      background: rgba(215, 215, 215, 0.6) url(${disabledIcon}) center center no-repeat;
      background-size: 20px 28px;
      pointer-events: auto;
    }
  `}
`

export default ColorsContainer

export interface IColorsContainerProps {
  mobile?: boolean
  withCheckbox?: boolean
  size?: number
  disabled?: boolean
}
